import ShopProductsSections from "./container";

export default ShopProductsSections;